"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CommunicationPreferencesInput_1 = require("./CommunicationPreferencesInput");
exports.CommunicationPreferencesInput = CommunicationPreferencesInput_1.default;
var ConsentToContactInput_1 = require("./ConsentToContactInput");
exports.ConsentToContactInput = ConsentToContactInput_1.default;
var DateOfBirthAgeInput_1 = require("./DateOfBirthAgeInput");
exports.DateOfBirthAgeInput = DateOfBirthAgeInput_1.default;
var EmailInput_1 = require("./EmailInput");
exports.EmailInput = EmailInput_1.default;
var FirstNameInput_1 = require("./FirstNameInput");
exports.FirstNameInput = FirstNameInput_1.default;
var MiddleNameInput_1 = require("./MiddleNameInput");
exports.MiddleNameInput = MiddleNameInput_1.default;
var LastNameInput_1 = require("./LastNameInput");
exports.LastNameInput = LastNameInput_1.default;
var NHSNumberInput_1 = require("./NHSNumberInput");
exports.NHSNumberInput = NHSNumberInput_1.default;
var PhonePrimaryInput_1 = require("./PhonePrimaryInput");
exports.PhonePrimaryInput = PhonePrimaryInput_1.default;
var PhoneSecondaryInput_1 = require("./PhoneSecondaryInput");
exports.PhoneSecondaryInput = PhoneSecondaryInput_1.default;
var ReferralsRequireApprovalInput_1 = require("./ReferralsRequireApprovalInput");
exports.ReferralsRequireApprovalInput = ReferralsRequireApprovalInput_1.default;
var SuffixInput_1 = require("./SuffixInput");
exports.SuffixInput = SuffixInput_1.default;
//# sourceMappingURL=index.js.map